/// <amd-module name="Repos/Views/Settings/Options/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\settings\options\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as Git from "Repos/Common/Contracts/Git";
import * as Policy from "Repos/Common/Contracts/Policy";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Retrieve a list of policy configurations by a given set of scope/filtering criteria.
     * 
     * @param project - Project ID or project name
     * @param repositoryId - The repository id.
     * @param refName - The fully-qualified Git ref name (e.g. refs/heads/master).
     * @param policyType - The policy type filter.
     * @param top - Maximum number of policies to return.
     * @param continuationToken - Pass a policy configuration ID to fetch the next page of results, up to top number of results, for this endpoint.
     */
    getPolicyConfigurations(project: string, repositoryId?: string, refName?: string, policyType?: string, top?: number, continuationToken?: string): Promise<Git.GitPolicyConfigurationResponse>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieve a list of policy configurations by a given set of scope/filtering criteria.
     * 
     * @param project - Project ID or project name
     * @param repositoryId - The repository id.
     * @param refName - The fully-qualified Git ref name (e.g. refs/heads/master).
     * @param policyType - The policy type filter.
     * @param top - Maximum number of policies to return.
     * @param continuationToken - Pass a policy configuration ID to fetch the next page of results, up to top number of results, for this endpoint.
     */
    public async getPolicyConfigurations(
        project: string,
        repositoryId?: string,
        refName?: string,
        policyType?: string,
        top?: number,
        continuationToken?: string
        ): Promise<Git.GitPolicyConfigurationResponse> {

        const queryValues: any = {
            repositoryId: repositoryId,
            refName: refName,
            policyType: policyType,
            '$top': top,
            continuationToken: continuationToken
        };

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/policy/configurations",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const result: Git.GitPolicyConfigurationResponse = {
                policyConfigurations: <Policy.PolicyConfiguration[]>body,
                continuationToken: response.headers.get("x-ms-continuationtoken")
            };
            return result;
        });
    }

}

export const GitClientName = "Repos.Settings.Options.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
